import {BasicProps} from "../Main";
import React, {useEffect, useState} from "react";
import {
    Grid,
    Collapse,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, useMediaQuery
} from "@mui/material";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {Colours, SamaggiTypography} from "../Components/SamaggiTypography";
import {SamaggiButton} from "../Components/SamaggiButton";
import axios from "axios";
import {handleError} from "../support";
import {useNavigate, useSearchParams} from "react-router-dom";
import theme from "../theme";
import {BudgetData, BudgetRequestData, BudgetRequestType, DynamoDBData, ReimbursementData} from "./NewReimbursements";


export function truncate(input: string, n: number = 12) {
    if (input.length > n) {
        return input.substring(0, n) + '...';
    }
    return input;
}

export const NewReimbursementsAdmin: React.FC<BasicProps> = (props) => {

    const [budgetRequestData, setBudgetRequestData] = useState<Array<BudgetRequestData>>([]);
    const [budgetData, setBudgetData] = useState<Array<BudgetData>>([]);

    const navigate = useNavigate();
    const vertical = useMediaQuery(theme.breakpoints.down("sm"));

    const [params, ] = useSearchParams();

    function showCover() {
        props.setShowCover(true);
    }

    function load() {
        const token = localStorage.getItem("token");

        props.setShowCover(true);

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/finance/list-all-budget-requests", {"token": token}).then((res) => {
            console.log(res, "LIST BUDGET REQUEST")

            const data: Array<BudgetRequestData> = [];
            res.data.data.data.forEach((value: DynamoDBData)=> { data.push(new BudgetRequestData(value)); });
            setBudgetRequestData(data);
        }).catch((error) => {
            console.log(error);
            handleError(error, false);
        })

        axios.post("https://usvj99ipg7.execute-api.eu-west-2.amazonaws.com/Prod/finance/list-all-budgets", {"token": token}).then((res) => {
            console.log(res, "LIST BUDGET");
            props.setShowCover(false);

            const data: Array<BudgetData> = [];
            res.data.data.data.forEach((value: DynamoDBData) => { data.push(new BudgetData(value)); })
            setBudgetData(data);
        }).catch((error) => {
            props.setShowCover(false);
            handleError(error, false);
        })
    }

    useEffect(() => {
        load() // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function ReimbursementRow(props: { row: ReimbursementData, defaultOpen?: boolean }) {
        const { row, defaultOpen = false } = props;
        const [open, setOpen] = useState(defaultOpen);

        return (
            <React.Fragment>
                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                    <TableCell align={"center"} sx={{padding: 0}}>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                            sx={{padding: "2px"}}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{truncate(row.description)}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{row.currency} {row.amount}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px", fontWeight: 600, color: (!row.approved ? "#000000" : !row.paid ? "#a80000" : "#008600")}}>{row.statusDisplay()}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit sx={{paddingLeft: 0, paddingRight: 0, paddingTop: 5, paddingBottom: 5}}>
                            <Grid container direction={"column"} spacing={4}>
                                <Grid item container direction={"column"} spacing={1.2}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            General
                                        </SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>ID: </SamaggiTypography>{row.id}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Description: </SamaggiTypography>{row.description}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Name: </SamaggiTypography>{row.name}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
										<SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Bank Account: </SamaggiTypography>{row.accountNumber} {row.sortCode}</SamaggiTypography>
									</Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Submitted: </SamaggiTypography>{(new Date(row.submittedTime)).toString()}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small>
                                            <SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Status: </SamaggiTypography>
                                            {row.responded ? (row.approved ? "Approved": "Rejected") : "Pending"} ({row.responded ? (new Date(row.approvedTime).toString()) : (new Date(row.submittedTime).toString())})</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Time Paid: </SamaggiTypography>{row.paid ? (new Date(row.paidTime)).toString() : "Not Paid"}</SamaggiTypography>
                                    </Grid>
                                </Grid>
                                <Grid item container direction={"column"} spacing={1.2}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            Files
                                        </SamaggiTypography>
                                    </Grid>
                                    <Grid item>
										<SamaggiButton fullWidth onClick={() => {window.open(row.receiptURL, "_blank")}}>View Receipt</SamaggiButton>
									</Grid>
                                </Grid>
                                {!row.paid && row.approved && <>
                                 <Grid item container direction={"column"} spacing={1.2}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            Actions
                                        </SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiButton colour={"#008600"} hoverColour={"#005c00"} fullWidth onClick={() => {row.markPaid(localStorage.getItem("token"), load); showCover()}}>Mark as Paid</SamaggiButton>
                                    </Grid>
                                </Grid>
								</>}
                            </Grid>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    function BudgetRow(props: { row: BudgetData, defaultOpen?: boolean }) {
        const { row, defaultOpen = false } = props;
        const [open, setOpen] = useState(defaultOpen);

        return (
            <React.Fragment>
                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                    <TableCell align={"center"} sx={{padding: 0}}>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                            sx={{padding: "2px"}}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{truncate(row.description)}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{row.currency} {row.totalAmount}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{row.currency} {row.remainingAmount}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{row.requiresAction}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit sx={{paddingLeft: 0, paddingRight: 0, paddingTop: 5, paddingBottom: 5}}>
                            <Grid container direction={"column"} spacing={4}>
                                <Grid item container direction={"column"} spacing={1.2}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            Reimbursements
                                        </SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>ID: </SamaggiTypography>{row.id}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Budget Description: </SamaggiTypography>{row.description}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="collapsible table" size={"small"}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell/>
                                                        <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Desc." : "Description"}</TableCell>
                                                        <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Amt." : "Amount"}</TableCell>
                                                        <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Stat." : "Status"}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {row.requests.sort((a,b) => b.submittedTime - a.submittedTime).map((_row) => (
                                                        <ReimbursementRow key={_row.submittedTime} row={_row} defaultOpen={shouldReimbursementOpen(_row.id)}/>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    function BudgetRequestRow(props: { row: BudgetRequestData, defaultOpen?: boolean }) {
        const { row, defaultOpen = false } = props;
        const [open, setOpen] = useState(defaultOpen);

        return (
            <React.Fragment>
                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                    <TableCell align={"center"} sx={{padding: 0}}>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                            sx={{padding: "2px"}}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{row.type === BudgetRequestType.New ? "New" : "Extend"}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{truncate(row.description)}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px"}}>{row.currency} {row.amount}</TableCell>
                    <TableCell align={"center"} sx={{padding: "2px", fontWeight: 600, color: (row.approved ? "#008600" : row.responded ? "#a80000" : "#000000")}}>{row.statusDisplay()}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                        <Collapse in={open} timeout="auto" unmountOnExit sx={{paddingLeft: 0, paddingRight: 0, paddingTop: 5, paddingBottom: 5}}>
                            <Grid container direction={"column"} spacing={4}>
                                <Grid item container direction={"column"} spacing={1.2}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            General
                                        </SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>ID: </SamaggiTypography>{row.id}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Description: </SamaggiTypography>{row.description}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small><SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Submitted: </SamaggiTypography>{(new Date(row.submittedTime)).toString()}</SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiTypography small>
                                            <SamaggiTypography bold small inline colour={Colours.samaggiOrange}>Status: </SamaggiTypography>
                                            {row.responded ? (row.approved ? "Approved": "Rejected") : "Pending"} ({row.responded ? (new Date(row.approvedTime).toString()) : (new Date(row.submittedTime).toString())})</SamaggiTypography>
                                    </Grid>
                                </Grid>
                                <Grid item container direction={"column"} spacing={1.2}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            Files
                                        </SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiButton fullWidth onClick={() => {window.open(row.projection, "_blank")}}>View Projection</SamaggiButton>
                                    </Grid>
                                </Grid>
                                {!row.responded && <Grid item container direction={"column"} spacing={1.2}>
                                    <Grid item>
                                        <SamaggiTypography large bold colour={Colours.samaggiOrange}>
                                            Actions
                                        </SamaggiTypography>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiButton colour={"#008600"} hoverColour={"#005c00"} fullWidth onClick={() => {row.approve(localStorage.getItem("token"), load); showCover()}}>Approve</SamaggiButton>
                                    </Grid>
                                    <Grid item>
                                        <SamaggiButton colour={"#a80000"} hoverColour={"#780000"} fullWidth onClick={() => {row.reject(localStorage.getItem("token"), load); showCover()}}>Reject</SamaggiButton>
                                    </Grid>
                                </Grid>}
                            </Grid>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    function shouldBudgetOpen(budgetID: string) {
        if (params.get("type") !== "r") {
            return false
        } else if (params.get("budget") === budgetID) {
            return true
        }
        return false
    }

    function shouldReimbursementOpen(reimbursementID: string) {
        if (params.get("type") !== "r") {
            return false
        } else if (params.get("req") === reimbursementID) {
            return true
        }
        return false
    }

    function shouldBudgetRequestOpen(budgetRequestID: string) {
        if (params.get("type") !== "b") {
            return false
        } else if (params.get("req") === budgetRequestID) {
            return true
        }
        return false
    }

    return (
        <Grid container direction={"column"} spacing={2}>
            <Grid item>
                <SamaggiTypography large bold colour={Colours.black}>All Budgets</SamaggiTypography>
            </Grid>
            <Grid item>
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table" size={"small"}>
                        <TableHead>
                            <TableRow>
                                <TableCell/>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Desc." : "Description"}</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Total Amt." : "Total Amount"}</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Remaining" : "Remaining Amount"}</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Act." : "Actions Required"}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {budgetData.sort((a,b) => b.createdTime - a.createdTime).map((row) => (
                                <BudgetRow key={row.createdTime} row={row} defaultOpen={shouldBudgetOpen(row.id)}/>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item>
                <SamaggiTypography large bold colour={Colours.black}>All Budget Requests</SamaggiTypography>
            </Grid>
            <Grid item>
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table" size={"small"}>
                        <TableHead>
                            <TableRow>
                                <TableCell/>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Typ." : "Type"}</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Desc." : "Description"}</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Amt." : "Amount"}</TableCell>
                                <TableCell align={"center"} sx={{padding: "1px"}}>{vertical ? "Stat." : "Status"}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {budgetRequestData.sort((a,b) => b.submittedTime - a.submittedTime).map((row) => (
                                <BudgetRequestRow key={row.submittedTime} row={row} defaultOpen={shouldBudgetRequestOpen(row.id)}/>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item>
                <SamaggiButton fullWidth colour={Colours.samaggiOrange} hoverColour={Colours.darkGray} onClick={() => {props.setShowCover(true); load()}}>Reload</SamaggiButton>
            </Grid>
            <Grid item>
                <SamaggiButton fullWidth colour={Colours.gray} hoverColour={Colours.darkGray} onClick={() => {navigate("/")}}>Back to Staff Portal</SamaggiButton>
            </Grid>
        </Grid>
    );
}
